import BaseApi from '../base/base'

export default class EmbedApi extends BaseApi {
  constructor() {
    super()
    this.path = '/embed'
  }

  async create(params: {
    targetId: number | string | any,
    type: string,
    embedToken?: string
  }): Promise<string>{
    this.path = '/embed/'
    const response = await this.postRequest(params)
    return response.data.embedOauth
  }
}
